import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { ExportData } from '../workforce.types';
import { WorkforceApiService } from '../workforce-api.service';

@Component({ selector: 'app-export', standalone: false, templateUrl: './export.component.html' })
export class ExportComponent implements OnInit, OnDestroy {
  private readonly api = inject(WorkforceApiService);
  private subscription?: Subscription;
  data: ExportData | null = null;
  error = '';
  loading = true;

  ngOnInit(): void { this.load(); }
  ngOnDestroy(): void { this.subscription?.unsubscribe(); }
  load(force = false): void {
    this.subscription?.unsubscribe();
    this.loading = true;
    this.error = '';
    this.data = null;
    this.subscription = this.api.get<ExportData>('/workforce/export', {}, force).subscribe({
      next: data => { this.data = data; this.loading = false; },
      error: error => { this.error = error.error?.message || error.error?.detail || 'Unable to load export data. Please retry.'; this.loading = false; },
    });
  }

  private escapeCsv(value: unknown): string {
    let cell = String(value ?? '');
    // Prevent spreadsheet applications from evaluating data as formulas.
    let prefix = 0;
    while (prefix < cell.length) {
      const character = cell[prefix];
      if (!(/\s/.test(character) || character.charCodeAt(0) <= 31)) break;
      prefix += 1;
    }
    if ('=+@-'.includes(cell[prefix])) cell = `'${cell}`;
    return `"${cell.replace(/"/g, '""')}"`;
  }

  downloadCsv(rows: Record<string, unknown>[], filename: string, groupLabel: string): void {
    if (!this.data) return;
    const columns = [groupLabel, 'Window Start', 'Window End Exclusive', 'Model Version', 'Generated At', 'Employee Count', 'Risk Score', 'Risk Band', ...(groupLabel === 'Department' ? ['Top Drivers'] : [])];
    const headers = rows.length ? Object.keys(rows[0]) : columns;
    const metadata = [
      ['# Reporting window start', this.data.windowStart],
      ['# Reporting window end (exclusive)', this.data.windowEndExclusive],
      ['# Model version', this.data.modelVersion],
      ['# Generated at (UTC)', new Date().toISOString()],
    ].map(row => row.map(value => this.escapeCsv(value)).join(','));
    const csv = [
      ...metadata,
      headers.map(value => this.escapeCsv(value)).join(','),
      ...rows.map(row => headers.map(header => this.escapeCsv(row[header])).join(',')),
    ].join('\n');
    const link = document.createElement('a');
    link.href = URL.createObjectURL(new Blob(['\uFEFF', csv], { type: 'text/csv;charset=utf-8' }));
    link.download = filename;
    link.click();
    setTimeout(() => URL.revokeObjectURL(link.href), 1000);
  }
}
